import { StudyPlanVisit } from '@curebase/core/types';

// StudyPlanVisit type helpers
export default function studyPlanIsRecurring(
  visit: Pick<StudyPlanVisit, 'rrule'>
) {
  return !!visit.rrule;
}
